<template>
  <div class="edit-email">
    <div class="card">
      <div class="card-header">
        <span class="card-title">修改邮箱</span>
      </div>
      <div class="card-body">
        <el-form :model="form" :rules="rules" ref="form" label-width="120px">
          <el-form-item label="原邮箱" prop="email">
            <el-input v-model="form.email" placeholder="请输入原邮箱" disabled></el-input>
          </el-form-item>
          <el-form-item label="新邮箱" prop="newEmail">
            <el-input v-model="form.newEmail" placeholder="请输入新邮箱"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="emailCode">
            <el-input v-model="form.emailCode" placeholder="请输入验证码" style="width: 200px;"></el-input>
            <el-button type="warning" style="margin-left: 10px;" @click="sendCode" :disabled="codeDisabled">{{ codeText }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="warning" @click="submitForm">保存</el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {emailCode,updateEmail} from '@/api/personal.js'
import { getUser } from '@/utils/auth.js'
import {getInfo} from '@/api/api';
export default {
  data() {
    return {
      form: {
        email: '',
        newEmail: '',
        emailCode: '',
      },
      rules: {
        newEmail: [
          { required: true, message: '请输入新邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
        ],
        emailCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      codeDisabled: false,
      codeText: '获取验证码',
      countdown: 60
    }
  },
  created(){
    this.form.email=getUser()&&getUser().email||''
  },
  methods: {
    sendCode() {
       emailCode({
        type:'changeEmail'
      }).then(res=>{
        if(res.data.code==200&&res.data.data){
          this.$message.success('验证码已发送至原邮箱')
        }
      })
      this.codeDisabled = true
      this.countdown = 60
      this.codeText = `${this.countdown}秒后重新获取`
      const timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(timer)
          this.codeDisabled = false
          this.codeText = '获取验证码'
        } else {
          this.codeText = `${this.countdown}秒后重新获取`
        }
      }, 1000)
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          updateEmail(
            {
                newEmail: this.form.newEmail,
                emailCode: this.form.emailCode
            }
          ).then(res=>{
            if(res.data.code==200&&res.data.data){
              this.$message.success('修改成功')
              this.form.email=this.form.newEmail
              this.form.newEmail=''
              this.form.emailCode=''
              getInfo().then(userRes => {
                if (userRes.data.code === 200) {
                  localStorage.setItem('userInfo', JSON.stringify(userRes.data.data))
                }
              })
            }
          })
        } else {
          return false
        }
      })
    },
    resetForm() {
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
.edit-email {
  height: 100%;
  .card {
    background: #fff;
    border-radius: 24px;
    padding: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    height: 100%;

    .card-header {
      margin-bottom: 20px;

      .card-title {
        font-size: 20px;
        font-weight: bold;
        color: #333333;
      }
    }

    .card-body {
    }

    .el-form {
      max-width: 600px;
    }
  }
}
</style>
